import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  collection,
  setDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  doc,
} from "firebase/firestore";

import { db } from "../Config/firebase";
import Navbar from "../Components/Navbar/navbar";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import { aplicarTenantAtual, consultaTenantAtual } from "../Utils/tenant";

const STATUS_OPTIONS = [
  { value: "pendente", label: "Pendente" },
  { value: "respondido", label: "Respondido" },
  { value: "inativo", label: "Inativo" },
];

function normalizarIdentificador(valor = "") {
  return String(valor)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/gi, "")
    .toLowerCase();
}

function ehKpiPsicossocial(kpi = {}) {
  const tipo = normalizarIdentificador(kpi.tipoFormulario);
  const nome = normalizarIdentificador(kpi.nome);
  const codigo = normalizarIdentificador(kpi.codigo);
  const ativo =
    kpi.ativo === true ||
    String(kpi.ativo || "").toLowerCase() === "true";

  return (
    ativo &&
    (
      tipo === "psicossocial" ||
      nome.includes("psicossoc") ||
      codigo === "rq103"
    )
  );
}

function gerarToken() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

function getBaseUrl() {
  return `${window.location.origin}/psicossocial/responder`;
}

function formatarCelular(celular = "") {
  return celular.replace(/\D/g, "");
}

function getLinkResposta(colaborador) {
  if (!colaborador?.token) return "";
  return `${getBaseUrl()}/${colaborador.token}`;
}

function getTelefoneWhatsApp(celular = "") {
  const telefone = formatarCelular(celular);
  if (!telefone) return "";
  return telefone.startsWith("55") ? telefone : `55${telefone}`;
}

function getMensagemWhatsApp(colaborador) {
  const link = getLinkResposta(colaborador);
  return `Ol\u00e1, ${colaborador.nome}. Acesse seu link individual para responder \u00e0 pesquisa psicossocial: ${link}`;
}

function getWhatsAppUrl(colaborador) {
  const telefone = getTelefoneWhatsApp(colaborador.celular);
  const texto = encodeURIComponent(getMensagemWhatsApp(colaborador));
  return `https://wa.me/${telefone}?text=${texto}`;
}

export default function CadastroPsicossocial() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const history = useHistory();
  const [colaboradores, setColaboradores] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [kpis, setKpis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [editando, setEditando] = useState(null);
  const [filtroCliente, setFiltroCliente] = useState("");
  const [pesquisa, setPesquisa] = useState("");
  const [copiadoId, setCopiadoId] = useState("");
  const [openEnvioTodos, setOpenEnvioTodos] = useState(false);
  const [form, setForm] = useState({
    clienteId: "",
    kpiId: "",
    nome: "",
    identificacao: "",
    dataNascimento: "",
    sexo: "",
    setor: "",
    funcao: "",
    celular: "",
    status: "pendente",
  });

  const [setores, setSetores] = useState([]);
const [funcoes, setFuncoes] = useState([]);

const [openNovoSetor, setOpenNovoSetor] = useState(false);
const [openNovaFuncao, setOpenNovaFuncao] = useState(false);

const [novoSetor, setNovoSetor] = useState("");

const [novaFuncao, setNovaFuncao] = useState({
  nome: "",
  setorId: "",
});

  async function carregar() {
    setLoading(true);

    const [
  clientesSnap,
  kpisSnap,
  colaboradoresSnap,
  setoresSnap,
  funcoesSnap,
] = await Promise.all([
      getDocs(consultaTenantAtual(query(collection(db, "clientes"), orderBy("nome")))),
      getDocs(consultaTenantAtual(collection(db, "kpis"))),
      getDocs(consultaTenantAtual(query(collection(db, "psicossocial_colaboradores"), orderBy("criadoEm", "desc")))),
        getDocs(consultaTenantAtual(query(collection(db, "kpi_setores"), orderBy("nome")))),
        getDocs(consultaTenantAtual(query(collection(db, "kpi_funcoes"), orderBy("nome")))),
        ]);

    setClientes(clientesSnap.docs.map((item) => ({ id: item.id, ...item.data() })));
    const kpisPsicossociais = kpisSnap.docs
      .map((item) => ({ id: item.id, ...item.data() }))
      .filter(ehKpiPsicossocial)
      .sort((a, b) =>
        String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR")
      );

    await Promise.all(
      kpisPsicossociais
        .filter(
          (kpi) =>
            kpi.tipoKPI !== "PESQUISA" ||
            kpi.tipoFormulario !== "PSICOSSOCIAL"
        )
        .map((kpi) =>
          updateDoc(doc(db, "kpis", kpi.id), {
            tipoKPI: "PESQUISA",
            tipoFormulario: "PSICOSSOCIAL",
            atualizadoEm: serverTimestamp(),
          })
        )
    );

    setKpis(
      kpisPsicossociais.map((kpi) => ({
        ...kpi,
        tipoKPI: "PESQUISA",
        tipoFormulario: "PSICOSSOCIAL",
      }))
    );
    setColaboradores(colaboradoresSnap.docs.map((item) => ({ id: item.id, ...item.data() })));
    setSetores(setoresSnap.docs.map((item) => ({
  id: item.id,
  ...item.data(),
})));

setFuncoes(funcoesSnap.docs.map((item) => ({
  id: item.id,
  ...item.data(),
})));
    setLoading(false);
  }

  useEffect(() => {
    carregar();
  }, []);

  const colaboradoresFiltrados = useMemo(() => {
    const termo = pesquisa.trim().toLowerCase();

    return colaboradores.filter((colaborador) => {
      const clienteOk = !filtroCliente || colaborador.clienteId === filtroCliente;
      const textoOk =
        !termo ||
        contemTextoPesquisa(String(colaborador.nome || "").toLowerCase(), termo) ||
        contemTextoPesquisa(String(colaborador.identificacao || "").toLowerCase(), termo) ||
        contemTextoPesquisa(String(colaborador.setor || "").toLowerCase(), termo) ||
        contemTextoPesquisa(String(colaborador.funcao || "").toLowerCase(), termo) ||
        contemTextoPesquisa(String(colaborador.celular || "").toLowerCase(), termo);

      return clienteOk && textoOk;
    });
  }, [colaboradores, filtroCliente, pesquisa]);

  const colaboradoresPendentes = useMemo(() => {
    return colaboradoresFiltrados.filter(
      (colaborador) =>
        colaborador.linkAtivo &&
        colaborador.status === "pendente" &&
        formatarCelular(colaborador.celular)
    );
  }, [colaboradoresFiltrados]);

  function abrirNovo() {
    const kpiPsicossocial = kpis[0];

    if (!kpiPsicossocial) {
      alert("KPI Fatores Psicossociais ativo não encontrado.");
      return;
    }

    setEditando(null);
    setForm({
      clienteId: filtroCliente || "",
      kpiId: kpiPsicossocial.id,
      nome: "",
      identificacao: "",
      dataNascimento: "",
      sexo: "",
      setor: "",
      funcao: "",
      celular: "",
      status: "pendente",
    });
    setOpenDialog(true);
  }

  function abrirEdicao(colaborador) {
    setEditando(colaborador);
    setForm({
      clienteId: colaborador.clienteId || "",
      kpiId: colaborador.kpiId || "",
      nome: colaborador.nome || "",
      identificacao: colaborador.identificacao || "",
      dataNascimento: colaborador.dataNascimento || "",
      sexo: colaborador.sexo || "",
      setor: colaborador.setor || "",
      funcao: colaborador.funcao || "",
      celular: colaborador.celular || "",
      status: colaborador.status || "pendente",
    });
    setOpenDialog(true);
  }

  async function salvar() {
    const kpi = kpis[0];

    if (!form.clienteId || !form.nome.trim() || !form.celular.trim()) {
      alert("Informe empresa, nome e celular.");
      return;
    }

    if (!kpi) {
      alert("KPI Fatores Psicossociais ativo não encontrado.");
      return;
    }

    const cliente = clientes.find((item) => item.id === form.clienteId);
    const kpiId = kpi.id;
    const status = editando?.status === "respondido" ? "respondido" : "pendente";
    const celularNormalizado = formatarCelular(form.celular);

    const celularJaCadastrado = colaboradores.some((colaborador) => {
      if (editando && colaborador.id === editando.id) return false;

      return (
        colaborador.clienteId === form.clienteId &&
        colaborador.kpiId === kpiId &&
        formatarCelular(colaborador.celularNormalizado || colaborador.celular) === celularNormalizado
      );
    });

    if (celularJaCadastrado) {
      alert("Este celular j\u00e1 est\u00e1 cadastrado para esta empresa e pesquisa psicossocial.");
      return;
    }

    setSalvando(true);

    await updateDoc(doc(db, "kpis", kpiId), {
      tipoKPI: "PESQUISA",
      tipoFormulario: "PSICOSSOCIAL",
      atualizadoEm: serverTimestamp(),
    });

    const dados = aplicarTenantAtual({
      clienteId: form.clienteId,
      clienteNome: cliente?.nome || "",
      kpiId,
      kpiNome: kpi?.nome || "",
      nome: form.nome.trim(),
      identificacao: form.identificacao.trim(),
      dataNascimento: form.dataNascimento || "",
      sexo: form.sexo || "",
      setor: form.setor.trim(),
      funcao: form.funcao.trim(),
      celular: form.celular.trim(),
      celularNormalizado,
      status,
      linkAtivo: status === "pendente",
      atualizadoEm: serverTimestamp(),
    });

    if (editando) {
      await updateDoc(doc(db, "psicossocial_colaboradores", editando.id), dados);
    } else {
      const token = gerarToken();

      await setDoc(doc(db, "psicossocial_colaboradores", token), {
        ...dados,
        token,
        criadoEm: serverTimestamp(),
      });
    }

    setOpenDialog(false);
    setSalvando(false);
    await carregar();
  }

  async function copiarLink(colaborador) {
    const link = getLinkResposta(colaborador);
    await navigator.clipboard.writeText(link);
    setCopiadoId(colaborador.id);
    window.setTimeout(() => setCopiadoId(""), 1800);
  }

  function enviarWhatsApp(colaborador) {
    window.open(getWhatsAppUrl(colaborador), "_blank", "noopener,noreferrer");
  }

  function enviarTodosWhatsApp() {
    colaboradoresPendentes.forEach((colaborador, index) => {
      window.setTimeout(() => {
        enviarWhatsApp(colaborador);
      }, index * 450);
    });
  }

  async function copiarTodosLinks() {
    const texto = colaboradoresPendentes
      .map((colaborador) => `${colaborador.nome} - ${colaborador.celular}\n${getMensagemWhatsApp(colaborador)}`)
      .join("\n\n");

    await navigator.clipboard.writeText(texto);
    alert("Links copiados para a \u00e1rea de transfer\u00eancia.");
  }
async function salvarNovoSetor() {
  if (!novoSetor.trim()) return;

  await setDoc(doc(collection(db, "kpi_setores")), aplicarTenantAtual({
    nome: novoSetor.trim(),
    ativo: true,
    createdAt: serverTimestamp(),
  }));

  setNovoSetor("");
  setOpenNovoSetor(false);
  await carregar();
}

async function salvarNovaFuncao() {
  if (!novaFuncao.nome.trim() || !novaFuncao.setorId) return;

  const setor = setores.find((s) => s.id === novaFuncao.setorId);

  await setDoc(doc(collection(db, "kpi_funcoes")), aplicarTenantAtual({
    nome: novaFuncao.nome.trim(),
    setorId: novaFuncao.setorId,
    setorNome: setor?.nome || "",
    ativo: true,
    createdAt: serverTimestamp(),
  }));

  setNovaFuncao({
    nome: "",
    setorId: "",
  });

  setOpenNovaFuncao(false);
  await carregar();
}
  return (
    <>
      <Navbar />

      <Box sx={{ p: 3, minHeight: "100vh", backgroundColor: "#f4f6f8" }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h5" fontWeight={700} mb={3}>
          Cadastro Psicossocial
        </Typography>

        <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={3}>
          <Button variant="contained" onClick={abrirNovo}>
              Novo colaborador
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                const primeiro = colaboradores.find((c) => c.token);

                if (!primeiro?.token) {
                  alert("Nenhum colaborador com link encontrado.");
                  return;
                }

                window.open(
                  `/psicossocial/resultados/${primeiro.token}`,
                  "_blank"
                );
              }}
            >
              Resultados
            </Button>

          <Button
            variant="outlined"
            color="success"
            startIcon={<WhatsAppIcon />}
            disabled={!colaboradoresPendentes.length}
            onClick={() => setOpenEnvioTodos(true)}
          >
            Enviar para todos
          </Button>

          <FormControl size="small" sx={{ minWidth: 260 }}>
            <InputLabel>Empresa</InputLabel>
            <Select value={filtroCliente} label="Empresa" onChange={(e) => setFiltroCliente(e.target.value)}>
              <MenuItem value="">Todas</MenuItem>
              {clientes.map((cliente) => (
                <MenuItem key={cliente.id} value={cliente.id}>
                  {cliente.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            size="small"
            label="Pesquisar"
            value={pesquisa}
            onChange={(e) => setPesquisa(e.target.value)}
            sx={{ flex: 1 }}
          />
        </Stack>
        </Paper>

        {!kpis.length && !loading && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Cadastre ou ative um KPI do tipo formul&aacute;rio PSICOSSOCIAL antes de gerar links.
          </Alert>
        )}

        <Paper>
          <Table className="lista-cadastro-padrao">
            <TableHead>
              <TableRow>
                <TableCell>Colaborador</TableCell>
                <TableCell>Empresa</TableCell>
                <TableCell>Setor / Fun&ccedil;&atilde;o</TableCell>
                <TableCell>Celular</TableCell>
                <TableCell>Status</TableCell>
                <TableCell width={320}>Link</TableCell>
                <TableCell width={120}>A&ccedil;&otilde;es</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={7}>Carregando...</TableCell>
                </TableRow>
              )}

              {!loading && colaboradoresFiltrados.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7}>Nenhum colaborador encontrado.</TableCell>
                </TableRow>
              )}
{colaboradoresFiltrados.map((colaborador) => {
  const linkDisponivel =
    colaborador.linkAtivo && colaborador.status === "pendente";

  return (
                  <TableRow key={colaborador.id} hover>
                    <TableCell>
                      <Typography className="lista-dado-principal">{colaborador.nome}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {colaborador.identificacao || "-"}
                      </Typography>
                    </TableCell>
                    <TableCell className="lista-dado-principal">{colaborador.clienteNome || "-"}</TableCell>
                    <TableCell>
                      <Typography variant="body2">{colaborador.setor || "-"}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {colaborador.funcao || "-"}
                      </Typography>
                    </TableCell>
                    <TableCell className="lista-dado-secundario">{colaborador.celular || "-"}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        color={colaborador.status === "respondido" ? "success" : colaborador.status === "inativo" ? "default" : "warning"}
                        label={STATUS_OPTIONS.find((item) => item.value === colaborador.status)?.label || colaborador.status}
                      />
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<ContentCopyIcon />}
                          disabled={!linkDisponivel}
                          onClick={() => copiarLink(colaborador)}
                        >
                          {copiadoId === colaborador.id ? "Copiado" : "Copiar"}
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          color="success"
                          startIcon={<WhatsAppIcon />}
                          disabled={!linkDisponivel}
                          onClick={() => enviarWhatsApp(colaborador)}
                        >
                          WhatsApp
                        </Button>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Button size="small" variant="outlined" onClick={() => abrirEdicao(colaborador)}>
                        Editar
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
          <DialogTitle>{editando ? "Editar colaborador" : "Novo colaborador"}</DialogTitle>
          <DialogContent dividers>
            <Stack spacing={2} mt={1}>
              <FormControl fullWidth>
                <InputLabel>Empresa</InputLabel>
                <Select value={form.clienteId} label="Empresa" onChange={(e) => setForm((prev) => ({ ...prev, clienteId: e.target.value }))}>
                  {clientes.map((cliente) => (
                    <MenuItem key={cliente.id} value={cliente.id}>
                      {cliente.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField label="Nome do colaborador" value={form.nome} onChange={(e) => setForm((prev) => ({ ...prev, nome: e.target.value }))} fullWidth />
              <TextField label={"Identifica\u00e7\u00e3o (CPF ou c\u00f3digo interno)"} value={form.identificacao} onChange={(e) => setForm((prev) => ({ ...prev, identificacao: e.target.value }))} fullWidth />
              <TextField
                label="Data de nascimento"
                type="date"
                value={form.dataNascimento}
                onChange={(e) => setForm((prev) => ({ ...prev, dataNascimento: e.target.value }))}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <FormControl fullWidth>
                <InputLabel>Sexo</InputLabel>
                <Select
                  value={form.sexo}
                  label="Sexo"
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, sexo: e.target.value }))
                  }
                >
                  <MenuItem value="">Não informado</MenuItem>
                  <MenuItem value="Masculino">Masculino</MenuItem>
                  <MenuItem value="Feminino">Feminino</MenuItem>
                </Select>
              </FormControl>
             <Stack direction="row" spacing={1}>
  <FormControl fullWidth>
    <InputLabel>Setor</InputLabel>

    <Select
      value={form.setor}
      label="Setor"
      onChange={(e) =>
        setForm((prev) => ({
          ...prev,
          setor: e.target.value,
          funcao: "",
        }))
      }
    >
      {setores.map((setor) => (
        <MenuItem key={setor.id} value={setor.nome}>
          {setor.nome}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

  <Button
    variant="outlined"
    onClick={() => setOpenNovoSetor(true)}
  >
    +
  </Button>
</Stack>
              <Stack direction="row" spacing={1}>
  <FormControl fullWidth>
    <InputLabel>Fun&ccedil;&atilde;o</InputLabel>

    <Select
      value={form.funcao}
      label={"Fun\u00e7\u00e3o"}
      onChange={(e) =>
        setForm((prev) => ({
          ...prev,
          funcao: e.target.value,
        }))
      }
      disabled={!form.setor}
    >

      
      {funcoes
        .filter((funcao) => funcao.setorNome === form.setor)
        .map((funcao) => (
          <MenuItem key={funcao.id} value={funcao.nome}>
            {funcao.nome}
          </MenuItem>
        ))}
    </Select>
  </FormControl>

  <Button
    variant="outlined"
    disabled={!form.setor}
    onClick={() => {
      const setor = setores.find((s) => s.nome === form.setor);

      setNovaFuncao((prev) => ({
        ...prev,
        setorId: setor?.id || "",
      }));

      setOpenNovaFuncao(true);
    }}
  >
    +
  </Button>
</Stack>
              <TextField label="Celular" value={form.celular} onChange={(e) => setForm((prev) => ({ ...prev, celular: e.target.value }))} fullWidth />

            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
            <Button variant="contained" disabled={salvando} onClick={salvar}>
              {salvando ? "Salvando..." : "Salvar"}
            </Button>
          </DialogActions>
        </Dialog>
<Dialog
  open={openNovoSetor}
  onClose={() => !salvandoCadastro && setOpenNovoSetor(false)}
  fullWidth
  maxWidth="xs"
>
  <DialogTitle>Novo setor</DialogTitle>

  <DialogContent dividers>
    <TextField
      label="Nome do setor"
      value={novoSetor}
      onChange={(e) => setNovoSetor(e.target.value)}
      fullWidth
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenNovoSetor(false)}>
      Cancelar
    </Button>

    <Button
      variant="contained"
      onClick={() => executarSalvamento(salvarNovoSetor)}
      disabled={salvandoCadastro}
    >
      {salvandoCadastro ? "Salvando..." : "Salvar"}
    </Button>
  </DialogActions>
</Dialog>

<Dialog
  open={openNovaFuncao}
  onClose={() => !salvandoCadastro && setOpenNovaFuncao(false)}
  fullWidth
  maxWidth="xs"
>
  <DialogTitle>Nova fun&ccedil;&atilde;o</DialogTitle>

  <DialogContent dividers>
    <Stack spacing={2} mt={1}>
      <FormControl fullWidth>
        <InputLabel>Setor</InputLabel>

        <Select
          value={novaFuncao.setorId}
          label="Setor"
          onChange={(e) =>
            setNovaFuncao((prev) => ({
              ...prev,
              setorId: e.target.value,
            }))
          }
        >
          {setores.map((setor) => (
            <MenuItem key={setor.id} value={setor.id}>
              {setor.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label={"Nome da fun\u00e7\u00e3o"}
        value={novaFuncao.nome}
        onChange={(e) =>
          setNovaFuncao((prev) => ({
            ...prev,
            nome: e.target.value,
          }))
        }
        fullWidth
      />
    </Stack>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenNovaFuncao(false)}>
      Cancelar
    </Button>

    <Button variant="contained" onClick={() => executarSalvamento(salvarNovaFuncao)} disabled={salvandoCadastro}>
      {salvandoCadastro ? "Salvando..." : "Salvar"}
    </Button>
  </DialogActions>
</Dialog>

        <Dialog open={openEnvioTodos} onClose={() => setOpenEnvioTodos(false)} fullWidth maxWidth="md">
          <DialogTitle>Enviar links pelo WhatsApp</DialogTitle>
          <DialogContent dividers>
            <Alert severity="info" sx={{ mb: 2 }}>
              O WhatsApp abre cada conversa com a mensagem pronta. Confirme o envio em cada janela ou aba aberta.
            </Alert>

            <Typography fontWeight={700} mb={2}>
              {colaboradoresPendentes.length} colaboradores pendentes
              {filtroCliente
                ? ` - ${clientes.find((cliente) => cliente.id === filtroCliente)?.nome || "empresa selecionada"}`
                : ""}
            </Typography>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Colaborador</TableCell>
                  <TableCell>Celular</TableCell>
                  <TableCell width={180}>A&ccedil;&atilde;o</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {colaboradoresPendentes.map((colaborador) => (
                  <TableRow key={colaborador.id}>
                    <TableCell>{colaborador.nome}</TableCell>
                    <TableCell>{colaborador.celular}</TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        variant="outlined"
                        color="success"
                        startIcon={<WhatsAppIcon />}
                        onClick={() => enviarWhatsApp(colaborador)}
                      >
                        Enviar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenEnvioTodos(false)}>Fechar</Button>
            <Button variant="outlined" startIcon={<ContentCopyIcon />} onClick={copiarTodosLinks}>
              Copiar todos
            </Button>
            <Button variant="contained" color="success" startIcon={<WhatsAppIcon />} onClick={enviarTodosWhatsApp}>
              Abrir todos
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
